import React from 'react';
import styled, { useStyles, cx, StylesProps } from '../../../lib/styles';
import theme from '../../../lib/theme';
import carouselItemStyles from './CarouselItem_styles';
const { media } = theme;

/*  Helpers */
export const hexToRGB = (hex: string, alpha: string) => {
  const r = parseInt(hex.slice(1, 3), 16);
  const g = parseInt(hex.slice(3, 5), 16);
  const b = parseInt(hex.slice(5, 7), 16);
  return alpha ? `rgba(${r}, ${g}, ${b}, ${alpha})` : `rgb(${r}, ${g}, ${b})`;
};

export const buildBackground = (image, colour1 = '', colour2 = '') => {
  // console.log(image);
  const gradient =
    colour1 && colour2
      ? `linear-gradient( 115deg, ${hexToRGB(colour1, '1')}, ${hexToRGB(
          colour2,
          '1'
        )})`
      : '';

  const background_url = image ? `url("${image}?w=1920")` : '';
  return gradient && background_url
    ? `${gradient}, ${background_url}`
    : gradient
    ? gradient
    : background_url;
};
/*******/

export interface CarouselItemProps {
  children: React.ReactNode;
  layout: string;
  brand?: string;
  makeContentWidth?: boolean;
}

export const CarouselItem = ({
  children,
  layout,
  brand,
  styles,
}: CarouselItemProps & StylesProps<typeof carouselItemStyles>) => {

  return (
    <div
      className={cx(
        `carousel-slide-container carousel-${layout} ${brand}-carousel-slide-container`,
        styles.carouselItem
      )}
    >
      {children}
    </div>
  );
};

export default styled(carouselItemStyles)(CarouselItem);
